import React from 'react';
import './OrderActionButtons.scss';
import { EOrderItemStatus } from '../../proto/order/orderItemStatus.enum';

interface IOrderActionButtonsProps {
	status: EOrderItemStatus;
	onClick: (newStatus: EOrderItemStatus) => void;
}

export const OrderActionButtons = ({ status, onClick }: IOrderActionButtonsProps): JSX.Element => {
	switch (status) {
		case EOrderItemStatus.PENDING:
			return (
				<div className="orderActionButtonsContainer">
					<div className="orderActionButton changeToPreparing" onClick={(): void => onClick(EOrderItemStatus.PREPARING)}>
						בהכנה
					</div>
					<div className="orderActionButton changeToCancelled" onClick={(): void => onClick(EOrderItemStatus.CANCELLED)}>
						מבוטל
					</div>
					<div className="orderActionButton changeToReady" onClick={(): void => onClick(EOrderItemStatus.COMPLETED)}>
						מוכן
					</div>
				</div>
			);
		case EOrderItemStatus.PREPARING:
			return (
				<div className="orderActionButtonsContainer">
					<div className="orderActionButton changeToPending" onClick={(): void => onClick(EOrderItemStatus.PENDING)}>
						בהמתנה
					</div>
					<div className="orderActionButton changeToCancelled" onClick={(): void => onClick(EOrderItemStatus.CANCELLED)}>
						מבוטל
					</div>
					<div className="orderActionButton changeToReady" onClick={(): void => onClick(EOrderItemStatus.COMPLETED)}>
						מוכן
					</div>
				</div>
			);
		case EOrderItemStatus.COMPLETED:
			return (
				<div className="orderActionButtonsContainer">
					<div className="orderActionButton changeToPending" onClick={(): void => onClick(EOrderItemStatus.PENDING)}>
						בהמתנה
					</div>
					<div className="orderActionButton changeToPreparing" onClick={(): void => onClick(EOrderItemStatus.PREPARING)}>
						בהכנה
					</div>
					<div className="orderActionButton changeToCancelled" onClick={(): void => onClick(EOrderItemStatus.CANCELLED)}>
						מבוטל
					</div>
				</div>
			);
		case EOrderItemStatus.CANCELLED:
			return (
				<div className="orderActionButtonsContainer">
					<div className="orderActionButton changeToPending" onClick={(): void => onClick(EOrderItemStatus.PENDING)}>
						בהמתנה
					</div>
					<div className="orderActionButton changeToPreparing" onClick={(): void => onClick(EOrderItemStatus.PREPARING)}>
						בהכנה
					</div>
					<div className="orderActionButton changeToReady" onClick={(): void => onClick(EOrderItemStatus.COMPLETED)}>
						מוכן
					</div>
				</div>
			);
		default:
			return null;
	}
};
